import Vue                  from "vue";
import { mapGetters }       from "vuex";
import { LoadingSpinner }   from "@/components";
import {
    ErrorLogService,
    PartsService }          from "@/services/";
import { PartInfo }         from "@/components/Elements/PartInfo";
import PartInfoCondensed from '@/components/Elements/PartInfoCondensed/PartInfoCondensed.vue';

import { DlTable }          from "@/components/Elements/DlTable";

// The data is really flat, each Id represented is a possible alternative part.
// Using this array to loop through and check values. 
const alternatePartCodes = ["EZId", "GPId", "KId", "NId", "OId", "RId", "VId", "XId", "XLId", "YId", "ZId", "ZZId"];

export default Vue.extend({
    name: "TmsPartInfo",
    components: {
        PartInfo,
        PartInfoCondensed,
        LoadingSpinner,
        DlTable
    },
    mixins: [
    ],
    created() {
        this.partInfo = this.partDetail;
        this.HasAltParts();
    },
    computed: {
        ...mapGetters([
            "user", 
            "audienceIds", 
            "activeAccountId",
            "getContentItem"
        ])
    },
    data: () => ({
        partInfo: {
            type: Object,
            default: () => {}
        },
        altPartTabs: [],
        isLoadingPartInfo: false,
        hasAltParts: false
    }),
    props: {
        partDetail: {
            type: Object,
            default: () => {}
        },
        compactView: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        "partDetail" () {
            this.partInfo = this.partDetail
        }
    },
    methods: {
        GetNewFullPartDetails: function(
            partId:{type: string, default: ""}, 
            partCode:{type: string, default: ""}
        ) {
            this.isLoadingPartInfo = true;
            this.partInfo.PartId = partId;
            try {
                PartsService.FullPartDetails(this.activeAccountId, this.user.UserId, partId, this.audienceIds, partCode)
                    .then(results => {
                        this.partInfo.FullPartDetails = results.data;
                    }).catch(err => {
                        ErrorLogService.LogAndGetErrorMessage(err);
                    }).finally(() => {
                        this.isLoadingPartInfo = false;
                    });
            } catch (err) {
                ErrorLogService.LogAndGetErrorMessage(err);
            };
        },
        isSerialPrefixOnly(groupNumber: String, serialPrefix: String) {
            return serialPrefix
                && !groupNumber;
        },
        isGroupNumberOnly(groupNumber: String, serialPrefix: String) {
            return groupNumber
                && !serialPrefix;
        },
        isGroupAndSerial(groupNumber: String, serialPrefix: String) {
            return serialPrefix
                && groupNumber;
        },
        HasAltParts() {
            alternatePartCodes.forEach(altPartCode => {
                if (this.IsNotNullOrUndefined(this.partDetail[altPartCode])) {
                    this.hasAltParts = true;
                }
            });
            
            if (this.hasAltParts) {
                this.$emit("hasAltParts", this.hasAltParts);

                this.SetUpAltButtonDetails();
            }
        },
        SetUpAltButtonDetails: function() {
            // Adding current/defaut part to beginning of array
            this.altPartTabs.push({
                title: this.partInfo.PartCode,
                id: this.partInfo.PartId
            })
            
            // Adding all appropriate parts to the array from the data using the const from above.
            alternatePartCodes.forEach(altPartCode => {
                if (this.IsNotNullOrUndefined(this.partDetail[altPartCode])) {
                    this.altPartTabs.push({
                        // removeing 'Id' from code to get the proper title
                        title: altPartCode.substring(0, altPartCode.length - 2),
                        id: this.partInfo[altPartCode]
                    });
                }
            });
        },
        SetScreenReaderTextForAltParts(title: string) {
            let altPartDesc = "";

            switch (title) {
                case "R":
                    altPartDesc = "Remanufactured";
                    break;
                case "XL":
                    altPartDesc = "Super XL";
                    break;
                case "Z":
                    altPartDesc = "Falcon Hyload";
                    break;
                case "GP":
                    altPartDesc = "Genuine Part";
                    break;
                case "X":
                    altPartDesc = "Falcon Standard";
                    break;
                case "EZ":
                    altPartDesc = "Superior EZ";
                    break;
                case "K":
                    altPartDesc = "Kit";
                    break;
                case "V":
                    altPartDesc = "Vulkollan";
                    break;
                case "Y":
                    altPartDesc = "Falcon SPS";
                    break;
                default:
                    return `Load part detail for part number ${this.partInfo.PartCode}.`
            }

            let readerText = `Load part detail for ${altPartDesc} alternative part.`;
            return readerText;
        }
    },
});
